/**
 * Loading message constants
 * 
 * Provides rotating loading messages with different color themes
 * to keep users engaged during matchmaking search operations.
 * Messages rotate every 3 seconds while loading.
 */

/**
 * Array of loading messages with color themes
 * Each message has a text and color property for UI display
 * Colors match the application's design system
 */
export const LOADING_MESSAGE_THEMES: { text: string; color: string }[] = [
  { text: "Hold on while we prepare the best match for you…", color: '#026857' }, // primary bQuest green
  { text: "Processing your request — this may take a moment....", color: '#378F94' }, // bQuest teal
  { text: "We're analyzing your preferences to find the right fit…", color: '#025247' }, // darker bQuest green
  { text: "Gathering data and aligning everything for you…", color: '#3E424F' }, // slate
  { text: "Optimizing results — just a little more patience…", color: '#026857' }, // primary bQuest green
  { text: "Finalizing your match — almost there…", color: '#6B7280' }, // neutral gray
  { text: "Everything is almost ready — thank you for waiting.", color: '#111827' }, 
];

/**
 * Example search questions for user guidance
 * These are sample prompts that demonstrate how to use the matchmaking feature
 * Can be used as placeholders or examples in the UI
 *
 * NOTE: These examples are written in first-person (Care Seeker perspective).
 * For Financial Advisors, the same questions work as they can search on behalf of clients.
 *
 * Updated to reflect more detailed examples showing the level of context Navigator needs.
 */
export const EXAMPLE_QUESTIONS = [
  "My father is showing early signs of dementia and needs in-home support. He's still independent but needs daily help, and the family wants someone experienced with memory care and communication challenges.",
  "Looking for an assisted living or senior community for my mother within the next 30 days. She has mobility limitations and mild cognitive decline, and the family wants a community with strong social engagement and a supportive care philosophy."
];

